import React from 'react'
import PropTypes from 'prop-types'

function getCategory(categories, category_id) {
  const filteredCategory = categories.filter(item => item.category.id === category_id) 
  if (filteredCategory.length === 0) {
    return {}
  }

  return filteredCategory[0].category
}

function NotificationPreviewItem({ notification, category }) {
  return (
    <li className='notification-preview-popup__item'>
      <a className='notification-preview-popup__link' href={notification.url}>
        {category.icon_url ?
          <img className='notification-preview-popup__category' src={category.icon_url} alt="" />
          : null}
        <p className='notification-preview-popup__text-content small-title-2'>
          {notification.title}: <b>{notification.body}</b>
        </p>
        {notification.image_url ?
          <img className='notification-preview-popup__image' src={notification.image_url} alt="" />
          : null}
      </a>
    </li>
  )
}

export function NotificationPreviewPopup({ data }) {
  const filteredNotifications = data.notifications.slice(0, 15)
  return (
    <div className='notification-preview-popup'>
      <div className='notification-preview-popup__header'>
        <h3 className='title-3'>Notifikasi</h3>
      </div>
      <ul className='notification-preview-popup__list'>
        {filteredNotifications.map(notification => {
          const category = getCategory(data.categories, notification.category_id)
          return (
            <NotificationPreviewItem
              key={`${notification.category_id}-${notification.timestamp}`}
              notification={notification}
              category={category}
            />
          )
        })}
      </ul>
      <div className='notification-preview-popup__footer'>
        <a className='notification-preview-popup__footer-text small-title-1' href="/notifications">
          Lihat lebih banyak notifikasi
        </a>
      </div>
    </div>
  )
}

NotificationPreviewPopup.propTypes = {
  data: PropTypes.shape({
    notifications: PropTypes.arrayOf(PropTypes.object),
    categories: PropTypes.arrayOf(PropTypes.object)
  }).isRequired
}
